import { render, staticRenderFns } from "./CaseLibrary.vue?vue&type=template&id=1272c0cb&scoped=true&"
import script from "./CaseLibrary.vue?vue&type=script&lang=js&"
export * from "./CaseLibrary.vue?vue&type=script&lang=js&"
import style0 from "./CaseLibrary.vue?vue&type=style&index=0&id=1272c0cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1272c0cb",
  null
  
)

export default component.exports